<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_hscode') || '海关HSCODE'"
            prop="hscode"
          >
            <el-input
              v-model="formData.hscode"
              :placeholder="$l('form_placeholder_hscode') || '请输入海关HSCODE'"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('form_hscodeName') || '商品中文名称'"
            prop="hscodeName"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('form_placeholder_hscodeName') || '请输入商品中文名称'
              "
              clearable
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('form_hscodeNameEn') || '商品英文名称'"
            prop="hscodeNameEn"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('form_placeholder_hscodeNameEn') || '请输入商品英文名称'
              "
              clearable
              maxlength="150"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_category') || '分类'">
            <dict-select
              v-model="formData.listCategoryCode"
              :placeholder="$l('form_placeholder_category') || '请选择分类'"
              url="/master/masterCategory/select"
              :body="{ parentCode: 'ABSHome' }"
              size="small"
              clearable
              multiple
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_declarationElements') || '申报要素'">
            <dict-select
              v-model="formData.listDeclarationCode"
              :placeholder="
                $l('form_placeholder_declarationElements') || '请输入申报要素'
              "
              url="/master/common/dict/biz"
              :body="{ dictType: 'declarationElements' }"
              size="small"
              clearable
              multiple
              filterable
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    shipmentCustomsCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { listDeclarationCode: [] },
      rules: {
        hscode: [
          {
            required: true,
            message: this.$l('form_placeholder_hscode') || '请输入海关HSCODE',
            trigger: 'blur',
          },
        ],
        hscodeName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_hscodeName') || '请输入商品中文名称',
            trigger: 'blur',
          },
        ],
        hscodeNameEn: [
          {
            required: true,
            message:
              this.$l('form_placeholder_hscodeNameEn') || '请输入商品英文名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.shipmentCustomsCode) return
      this.$api
        .shipmentCustomsCodeDetailApi({
          shipmentCustomsCode: this.shipmentCustomsCode,
        })
        .then((res) => {
          const { body } = res
          const { declarationElements } = body
          this.formData = {
            ...body,
            listDeclarationCode: declarationElements
              ? declarationElements.split(',')
              : [],
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { listDeclarationCode } = this.formData
      this.formData.declarationElements = listDeclarationCode.join()

      this.loadingOpen()
      this.$api
        .shipmentCustomsCodeSaveApi(this.formData)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
